<template>
  <div :class="classModifiers" :style="styleModifiers" @click="onTooltipClick">
    <div :class="titleClassModifiers" :style="titleStyleModifiers">
      {{ stateName }}
      <template v-if="!isSenate"
        >({{ marketData.stateVotes }}<span v-if="showNote"> STATEWIDE</span>)</template
      ><template v-else-if="isSenate && stateCode === 'GA'">(REGULAR)</template
      ><template v-else-if="isSenate && stateCode === 'GA2'">(SPECIAL)</template>
    </div>
    <template v-if="winnerMode">
      <div class="market-state-tooltip__winner">
        <div class="market-state-tooltip__winner-title">
          {{ targetContract.contractName }}
        </div>
        <div
          class="market-state-tooltip__winner-image"
          :style="imageStyleModifiers(targetContract)"
        ></div>
        <div
          class="market-state-tooltip__winner-name"
          :style="winnerBgColorStyleModifiers"
          v-if="showNote"
        ></div>
        <div class="market-state-tooltip__winner-price">
          <span class="market-state-tooltip__winner-current-price">
            <template v-if="targetContractInstance.hasLastTradePrice">
              <animated-number
                :value="targetContractInstance.lastTradePriceAsCents"
              ></animated-number>
            </template>
            <template v-else> - </template>
          </span>
          <market-change-price
            :price="targetContractInstance.changePriceAsCents"
            :lastClosePrice="targetContractInstance.lastClosePrice"
            theme="chart"
          >
          </market-change-price>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(contract, index) in contracts"
        :key="contract.contractId"
        :class="contractClassModifiers(contract, index)"
      >
        <div
          class="market-state-tooltip__contract-image"
          :style="imageStyleModifiers(contract)"
        ></div>
        <div class="market-state-tooltip__contract-info">
          <div class="market-state-tooltip__contract-name">
            {{ getNameDisplay(contract) }}
          </div>
          <div class="market-state-tooltip__contract-price">
            <span class="market-state-tooltip__contract-current-price">
              <template v-if="contract.hasLastTradePrice">
                <animated-number :value="contract.lastTradePriceAsCents"></animated-number>
              </template>
              <template v-else> - </template>
            </span>
            <market-change-price
              :price="contract.changePriceAsCents"
              :lastClosePrice="contract.lastClosePrice"
              theme="chart"
            >
            </market-change-price>
          </div>
        </div>
      </div>
    </template>
    <div class="market-state-tooltip__note" v-if="showNote">
      See separate markets for individual <br />congressional districts in
      {{ capitalizeFirstLetter(stateName.toLowerCase()) }}.
    </div>
  </div>
</template>

<script src="./market-state-tooltip.js"></script>
<style src="./market-state-tooltip.scss" lang="scss"></style>
